import { render, staticRenderFns } from "./EditItemInOrder.vue?vue&type=template&id=4823e5c3"
import script from "./EditItemInOrder.vue?vue&type=script&lang=js"
export * from "./EditItemInOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports